module.exports = __webpack_public_path__ + "../resources/img/ic-re-refresh-2.1b82b0bb.svg";